import { put, call, take, fork } from 'redux-saga/effects'
import { questionLinkDeleteService } from '../../api/question'
import { questionLinkDeleteSuccess } from '../../reducers/assignment/action'
import { QUESTION_LINK_DELETE } from '../../reducers/question/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* questionLinkDeleteFlow(payload) {
  try {
    const { id, questionId, callback } = payload
    yield call(questionLinkDeleteService, id)

    yield put(questionLinkDeleteSuccess(id, questionId))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* questionLinkDeleteWatcher() {
  while (true) {
    const action = yield take(QUESTION_LINK_DELETE)
    const { payload } = action

    yield fork(generalSaga, questionLinkDeleteFlow, payload)
  }
}
